import React, { Component } from 'react'

export default class AirScroll extends Component {
  state = {
    top: 0,
  }

  lastScrollTop = 0
  startTop = 0

  constructor(props) {
    super(props)

    this.slowDiv = React.createRef()
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') { window.onscroll = null }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.onscroll = this.onScroll
      this.slowDiv.current.style.top = `${this.slowDiv.current.offsetTop}px`
      this.startTop = this.slowDiv.current.offsetTop
      this.slowDiv.current.style.position = 'absolute'
    }
    this.setState({ top: this.slowDiv.current.offsetTop })
  }

  onScroll = () => {
    this.moveLittle(this.props.speed, window.scrollY);
  }

  moveLittle = (speed, scrollY) => {
    //Get the current top of the slow element
    let top = parseInt(this.slowDiv.current.style.top)

    //Check scroll direction
    // if (this.isScrollingDown(scrollY)) {
    top = this.startTop - (scrollY * speed);
    // } else {
    // top = this.startTop + (scrollY * speed);
    // }

    this.setState({
      top
    })
  }

  isScrollingDown = (scrollY) => {
    let retVal = false;
    if (scrollY >= this.lastScrollTop) {
      retVal = true;
    }
    this.lastScrollTop = scrollY
    return retVal;
  };


  render() {
    const { top } = this.state
    return (
      <div className="air-scroll" ref={this.slowDiv} style={{ top: `${top}px` }}>
        {this.props.children}
      </div>
    )
  }
}



// var moveLittle = function ;

// var isScrollingDown = function

// window.onscroll = function WindowScroll() {
//   //Send speed and current scroll Y
//   moveLittle(10, this.scrollY);
// }

